import { prop } from 'ramda';

import * as actions from 'constants/actionTypes';

const titleGetters = {
    [actions.OPEN_MODAL_DOCUMENT_VIEW]: prop('name'),
    [actions.OPEN_MODAL_PERSON]: prop('value'),
    [actions.OPEN_MODAL_EVENT]: prop('value'),
    [actions.OPEN_MODAL_PROJECT]: prop('text'),
    [actions.OPEN_MODAL_COMPANY]: prop('text')
}

export const getCollapsibleTitle = modal => {
    return titleGetters[modal.type](modal.params);
};
